import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const driverBaseEndpoint = ENDPOINTS.DRIVER;

// Package Type API
export const driverApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["drivers"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDrivers: builder.query({
        query: (payload) => `${driverBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "drivers" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addDriver: builder.mutation({
        query: (requestData) => ({
          url: `${driverBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "drivers" }],
      }),
      updateDriver: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${driverBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "drivers" }],
      }),
      deleteDriver: builder.mutation({
        query: (id) => ({
          url: `${driverBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "drivers" }],
      }),
      toggleDriverStatus: builder.mutation({
        query: (id) => ({
          url: `${driverBaseEndpoint}/toggle-driver/${id}`,
          method: METHODS.PATCH,
        }),
        invalidatesTags: () => [{ type: "drivers" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetDriversQuery,
  useAddDriverMutation,
  useUpdateDriverMutation,
  useToggleDriverStatusMutation,
  useDeleteDriverMutation
} = driverApi;
